import ProductInfo from './ProductInfo.jsx';

export {
  ProductInfo
}


// WEBPACK FOOTER //
// ./components/partials/product/popup-view-detail/product-info/index.js